<template>
  <svg
    width="20"
    height="20"
  >
    <rect
      width="20"
      height="20"
      fill="var(--logo)"
      rx="4"
    />
    <path
      fill="#051230"
      d="M5.52 11.459c0 .975.526 1.564 1.397 1.564.284 0 .548-.061.852-.163v.102c-.507.792-1.216 1.219-2.107 1.219-1.176 0-2.027-.752-2.028-2.153V8.289H2.5v-.142l2.857-2.622h.162zm6.227.522-.976 2.146h-.122l-2.581-5.83H5.994v-.89h3.761zm3.656 0-.948 2.146h-.141l-2.944-6.72h2.057zm.811-1.994h-.08c0-.63-.281-1.91-.623-2.58H17.5z"
    />
  </svg>
</template>
